namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_speech, {

		align: {
			items: 'center',
		},
		// gap: '2px',
		flex: {
			direction: 'row',
		},

		Toggle: {
			position: 'relative',
		},
		
		Enabled: {
			background: {
				color: 'red',
			},
			padding: 0,
			margin: 0,
			right: '6px',
			top: '5px',
			width: '6px',
			height: '6px',
			minHeight: '6px',
			minWidth: '6px',
		},
		Toggle_icon: {
			width: '1.25rem',
			height: '1.25rem',
		},

		Picker: {
			Trigger: {
				justify: {
					content: 'center',
				},
			},
		},
		
	} )
	
}
